module.exports = __webpack_public_path__ + "static/media/ic_cloud_upload_24px.89354cca.svg";